import { useSearchParams } from "react-router-dom";
import LoginPage from "./LoginPage";

export default function InscriptionPage() {
  const [params] = useSearchParams();
  return <LoginPage inviteCode={(params.get("code") || "").toUpperCase()} />;
}
